module.exports = __webpack_public_path__ + "static/media/downArrow_disabled.76f8b237.svg";